<template>
  <div class="cs-box-item">
    <div
      class="product-name mb-50 d-flex justify-content-center"
    >
      <feather-icon
        :icon="hasUploadedFiles ? 'CheckCircleIcon' : 'AlertCircleIcon'"
        size="22"
        class="text-success mr-auto"
        :class="hasUploadedFiles ? 'text-success' : 'text-warning'"
      />

      <span
        class="text-primary text-center"
        style="font-weight: 500; font-size: 18px; flex: 1"
        >{{ form.form_name }}</span
      >
    </div>
    <div class="d-flex items-center my-2" :class="hasUploadedFiles || 'justify-center'">
      <div v-if="hasUploadedFiles" class="d-flex flex-column justify-center" style="gap: 5px;">
        <div
          v-for="(urlFileUploaded, fileIndex) in url_list"
          :key="
            typeof urlFileUploaded === 'object'
              ? urlFileUploaded.url + fileIndex
              : urlFileUploaded + fileIndex
          "
          class="d-flex flex-nowrap justify-between" style="flex: 1; gap: 20px;"
        >
          <b-link
            :href="
              typeof urlFileUploaded === 'object'
                ? urlFileUploaded.url
                : urlFileUploaded
            "
            v-b-tooltip.top
            :title="getFileName(urlFileUploaded)"
            target="_blank"
            class="flex"
            style="gap: 6px"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 10H10C10.2652 10 10.5196 9.89464 10.7071 9.70711C10.8946 9.51957 11 9.26522 11 9C11 8.73478 10.8946 8.48043 10.7071 8.29289C10.5196 8.10536 10.2652 8 10 8H9C8.73478 8 8.48043 8.10536 8.29289 8.29289C8.10536 8.48043 8 8.73478 8 9C8 9.26522 8.10536 9.51957 8.29289 9.70711C8.48043 9.89464 8.73478 10 9 10ZM9 12C8.73478 12 8.48043 12.1054 8.29289 12.2929C8.10536 12.4804 8 12.7348 8 13C8 13.2652 8.10536 13.5196 8.29289 13.7071C8.48043 13.8946 8.73478 14 9 14H15C15.2652 14 15.5196 13.8946 15.7071 13.7071C15.8946 13.5196 16 13.2652 16 13C16 12.7348 15.8946 12.4804 15.7071 12.2929C15.5196 12.1054 15.2652 12 15 12H9ZM20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11C13.4402 2.10576 13.4099 2.10576 13.38 2.11C13.2784 2.05174 13.1662 2.01434 13.05 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H15C14.7348 8 14.4804 7.89464 14.2929 7.70711C14.1054 7.51957 14 7.26522 14 7V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V7C12 7.79565 12.3161 8.55871 12.8787 9.12132C13.4413 9.68393 14.2044 10 15 10H18V19ZM15 16H9C8.73478 16 8.48043 16.1054 8.29289 16.2929C8.10536 16.4804 8 16.7348 8 17C8 17.2652 8.10536 17.5196 8.29289 17.7071C8.48043 17.8946 8.73478 18 9 18H15C15.2652 18 15.5196 17.8946 15.7071 17.7071C15.8946 17.5196 16 17.2652 16 17C16 16.7348 15.8946 16.4804 15.7071 16.2929C15.5196 16.1054 15.2652 16 15 16Z"
                fill="#20419b"
              />
            </svg>
            <span style="flex: 1; line-height: 24px; text-wrap: nowrap;">{{ getFileName(urlFileUploaded) }}</span>
          </b-link>
          <svg
            @click="deleteFile(fileIndex)"
            v-b-tooltip.top
            :title="disableMessage"
            class="cursor-pointer"
            width="24"
            height="24"
            viewBox="0 0 24 24" 
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12.0001 10.9392L5.6361 4.5752L4.57544 5.63586L10.9394 11.9998L4.57544 18.3638L5.6361 19.4244L12.0001 13.0605L18.364 19.4244L19.4247 18.3638L13.0607 11.9998L19.4247 5.63586L18.364 4.5752L12.0001 10.9392Z"
              fill="grey"/>
          </svg>
        </div>
      </div>
      <div
        v-b-tooltip.top
        :title="disableMessage"
        class="d-flex align-items-center justify-content-center my-1 flex-wrap w-100"
      >
        <button
          :disabled="isDisabled"
          class="button-none"
          v-b-tooltip.top
          :title="$t('lbl_upload')"
          @click="handleTriggerUploadFile('upload' + form.id)" 
        >
          <svg 
            style="width: 30px; height: 30px;"
            class="text-primary cursor-pointer"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M18.4199 8.2199C17.8089 6.8159 16.7544 5.65097 15.418 4.90362C14.0815 4.15627 12.5369 3.86773 11.0209 4.0822C9.50477 4.29668 8.10082 5.00235 7.02415 6.09107C5.94747 7.17979 5.25748 8.59151 5.05989 10.1099C4.10648 10.3382 3.27011 10.9087 2.70963 11.7131C2.14914 12.5174 1.90357 13.4996 2.01955 14.4731C2.13553 15.4466 2.60498 16.3436 3.33876 16.9938C4.07253 17.6439 5.01952 18.002 5.99989 17.9999C6.26511 17.9999 6.51946 17.8945 6.707 17.707C6.89453 17.5195 6.99989 17.2651 6.99989 16.9999C6.99989 16.7347 6.89453 16.4803 6.707 16.2928C6.51946 16.1053 6.26511 15.9999 5.99989 15.9999C5.46946 15.9999 4.96075 15.7892 4.58568 15.4141C4.2106 15.039 3.99989 14.5303 3.99989 13.9999C3.99989 13.4695 4.2106 12.9608 4.58568 12.5857C4.96075 12.2106 5.46946 11.9999 5.99989 11.9999C6.26511 11.9999 6.51946 11.8945 6.707 11.707C6.89453 11.5195 6.99989 11.2651 6.99989 10.9999C7.00244 9.81717 7.42418 8.67365 8.19016 7.77248C8.95614 6.87131 10.0168 6.27085 11.1836 6.07777C12.3505 5.88469 13.548 6.1115 14.5635 6.7179C15.5789 7.32431 16.3465 8.27104 16.7299 9.3899C16.7871 9.56174 16.8898 9.71483 17.0272 9.83283C17.1646 9.95083 17.3314 10.0293 17.5099 10.0599C18.176 10.1858 18.7798 10.5335 19.2229 11.0464C19.6661 11.5594 19.9225 12.2073 19.9503 12.8845C19.9781 13.5618 19.7758 14.2286 19.3762 14.7761C18.9766 15.3237 18.4034 15.7198 17.7499 15.8999C17.4926 15.9662 17.2722 16.132 17.1372 16.3608C17.0022 16.5896 16.9636 16.8626 17.0299 17.1199C17.0962 17.3772 17.262 17.5975 17.4908 17.7326C17.7196 17.8676 17.9926 17.9062 18.2499 17.8399C19.3023 17.5618 20.2352 16.9479 20.9069 16.0914C21.5786 15.2348 21.9525 14.1825 21.9717 13.0942C21.991 12.0058 21.6545 10.9409 21.0135 10.0612C20.3724 9.18149 19.4618 8.53499 18.4199 8.2199ZM12.7099 10.2899C12.6148 10.1989 12.5026 10.1275 12.3799 10.0799C12.1364 9.97988 11.8634 9.97988 11.6199 10.0799C11.4971 10.1275 11.385 10.1989 11.2899 10.2899L8.28989 13.2899C8.10159 13.4782 7.9958 13.7336 7.9958 13.9999C7.9958 14.2662 8.10159 14.5216 8.28989 14.7099C8.47819 14.8982 8.73359 15.004 8.99989 15.004C9.26619 15.004 9.52159 14.8982 9.70989 14.7099L10.9999 13.4099V18.9999C10.9999 19.2651 11.1052 19.5195 11.2928 19.707C11.4803 19.8945 11.7347 19.9999 11.9999 19.9999C12.2651 19.9999 12.5195 19.8945 12.707 19.707C12.8945 19.5195 12.9999 19.2651 12.9999 18.9999V13.4099L14.2899 14.7099C14.3829 14.8036 14.4935 14.878 14.6153 14.9288C14.7372 14.9796 14.8679 15.0057 14.9999 15.0057C15.1319 15.0057 15.2626 14.9796 15.3845 14.9288C15.5063 14.878 15.6169 14.8036 15.7099 14.7099C15.8036 14.6169 15.878 14.5063 15.9288 14.3845C15.9796 14.2626 16.0057 14.1319 16.0057 13.9999C16.0057 13.8679 15.9796 13.7372 15.9288 13.6153C15.878 13.4935 15.8036 13.3829 15.7099 13.2899L12.7099 10.2899Z" 
              fill="currentColor"/>
          </svg>
        </button>
        <button
          v-if="form.form_type !== 100"
          :disabled="isDisabled"
          class="button-none" 
          @click="$emit('create')"
          v-b-tooltip.top
          :title="$t(orderItem.formData ? 'lbl_change' : 'lbl_create') + ' E-form'"
        >
          <svg
            width="36"
            height="36"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="text-primary cursor-pointer"
            :style="{width: orderItem.formData ? '25px' : '30px'}"
          >
            <path
              v-if="orderItem.formData"
              d="M21 11.9999C20.7348 11.9999 20.4804 12.1053 20.2929 12.2928C20.1054 12.4804 20 12.7347 20 12.9999V18.9999C20 19.2652 19.8946 19.5195 19.7071 19.707C19.5196 19.8946 19.2652 19.9999 19 19.9999H5C4.73478 19.9999 4.48043 19.8946 4.29289 19.707C4.10536 19.5195 4 19.2652 4 18.9999V4.99994C4 4.73472 4.10536 4.48037 4.29289 4.29283C4.48043 4.1053 4.73478 3.99994 5 3.99994H11C11.2652 3.99994 11.5196 3.89458 11.7071 3.70705C11.8946 3.51951 12 3.26516 12 2.99994C12 2.73472 11.8946 2.48037 11.7071 2.29283C11.5196 2.1053 11.2652 1.99994 11 1.99994H5C4.20435 1.99994 3.44129 2.31601 2.87868 2.87862C2.31607 3.44123 2 4.20429 2 4.99994V18.9999C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 21.9999 5 21.9999H19C19.7956 21.9999 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 18.9999V12.9999C22 12.7347 21.8946 12.4804 21.7071 12.2928C21.5196 12.1053 21.2652 11.9999 21 11.9999ZM6 12.7599V16.9999C6 17.2652 6.10536 17.5195 6.29289 17.707C6.48043 17.8946 6.73478 17.9999 7 17.9999H11.24C11.3716 18.0007 11.5021 17.9755 11.6239 17.9257C11.7457 17.8759 11.8566 17.8026 11.95 17.7099L18.87 10.7799L21.71 7.99994C21.8037 7.90698 21.8781 7.79637 21.9289 7.67452C21.9797 7.55266 22.0058 7.42195 22.0058 7.28994C22.0058 7.15793 21.9797 7.02722 21.9289 6.90536C21.8781 6.7835 21.8037 6.6729 21.71 6.57994L17.47 2.28994C17.377 2.19621 17.2664 2.12182 17.1446 2.07105C17.0227 2.02028 16.892 1.99414 16.76 1.99414C16.628 1.99414 16.4973 2.02028 16.3754 2.07105C16.2536 2.12182 16.143 2.19621 16.05 2.28994L13.23 5.11994L6.29 12.0499C6.19732 12.1434 6.12399 12.2542 6.07423 12.376C6.02446 12.4979 5.99924 12.6283 6 12.7599ZM16.76 4.40994L19.59 7.23994L18.17 8.65994L15.34 5.82994L16.76 4.40994ZM8 13.1699L13.93 7.23994L16.76 10.0699L10.83 15.9999H8V13.1699Z"
              fill="currentColor"
            />
            <template v-else>
              <path
                d="M13 11H17V13H13V17H11V13H7V11H11V7H13V11Z"
                fill="currentColor"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
                fill="currentColor"
              />
            </template>
          </svg>
        </button>
      </div>
    </div>
    <p v-if="form.form_type === 1" class="description">
      {{ $t("submit_form.lbl_view_example_commitment_form") }}
      <b-link
        href="https://api-dev.hodo.app/api/go/static/uploads//905/AGTC_Consent_Form_Clinical_Services_V3.pdf"
        target="_blank"
        >{{ $t("submit_form.lbl_here") }}</b-link
      >
    </p>
    <input
      v-show="false"
      type="file"
      :ref="'upload' + form.id"
      multiple
      @change="(e) => requestUploadFile(e.target.files)"
    />
  </div>
</template>

<script>
import {
  ORDER_FORM_PROCESSOR_STATUS,
  RESULT_ORDER_ITEM_STATUS
} from "@/utils/constant";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import appUtils from "@/utils/appUtils";

export default {
  name: "SubmitFormItemSection",
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    orderItem: {
      type: Object,
      default: () => {}
    },
    apiPayload: {
      type: Object,
      default: () => {}
    },
    isCancelOrder: Boolean
  },
  data() {
    return {
      url_list: [],
      isDisabled: false,
      isSended: false,
      disableMessage: "",
      appUtils
    }
  },
  computed: {
    hasUploadedFiles() {
      return this.url_list && this.url_list.length
    }
  },
  created() {
    this.getStatusAndMessage()
    this.getUrlList()
    if (this.$route.params.url 
      && this.orderItem.data.id === this.$route.params.item_id 
      && this.form.id === +this.$route.params.form_id 
      && !this.url_list.includes(this.$route.params.url)
    ) {
      this.url_list = [...this.url_list, this.$route.params.url]
      this.$emit("upload", this.url_list)
    }
  },
  methods: {
    deleteFile(fileIndex) {
      if (this.isDisabled) return
      this.url_list.splice(fileIndex, 1)
      this.$emit("upload", this.url_list)
    },
    getUrlList() {
      // In case user has upload files
      if (this.apiPayload) {
        switch (this.form.form_type) {
          case 1:
            this.url_list = (this.apiPayload.url_concent_form.length && this.apiPayload.url_concent_form) ? this.apiPayload.url_concent_form : []
            break;
          case 2:
            this.url_list = (this.apiPayload.url_requisition_form.length && this.apiPayload.url_requisition_form) ? this.apiPayload.url_requisition_form : []
            break;
          case 3:
          this.url_list = (this.apiPayload.url_order_form.length && this.apiPayload.url_order_form) ? this.apiPayload.url_order_form : []
            break;
          default:
            this.url_list = (this.apiPayload.url_other_form.length && this.apiPayload.url_other_form) ? this.apiPayload.url_other_form : []
            break;
        }
      } else if (this.orderItem.data.order_processor) {
      // In case get list files from api
        switch (this.form.form_type) {
          case 1:
            this.url_list = this.orderItem.data.order_processor ? JSON.parse(this.orderItem.data.order_processor?.concent_form_url).map(form => form.url) : []
            break;
          case 2:
            this.url_list = this.orderItem.data.order_processor ? this.orderItem.data.order_processor?.requisition_form?.filter(form => form.type === 1).map(form => form.url) : []
            break;
          case 3:
            this.url_list = this.orderItem.data.order_processor ? JSON.parse(this.orderItem.data.order_processor?.order_form_url).map(form => form.url) : []
            break;
          default:
            this.url_list = this.orderItem.data.order_processor ? this.orderItem.data.order_processor?.requisition_form?.filter(form => form.type === 2).map(form => form.url) : []
            break;
        }
      }
    },
    handleTriggerUploadFile(ref) {
      this.$refs[`${ref}`]?.click();
    },
    async requestUploadFile(files) {
      if (!files?.length) return;
      try {
        this.loading = true;
        let formUrlArr = new Array(files.length);
        const promise_list = Array.from(files).map(async (file, fileIndex) => {
          const params = {
            file: file,
            NameTarget: "AttachedFormFolder",
            IdTarget: this.orderItem.data.id
          };
          const formData = new FormData();

          for (const key in params) {
            formData.append(key, params[key]);
          }

          let data = await this.$rf
            .getRequest("CommonRequest")
            .uploadFileTenant(formData);
          formUrlArr[fileIndex] = data.data.fileUrl;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t("lbl_upload_file_successfully"),
              icon: "CheckIcon",
              variant: "success"
            }
          });
          return;
        });
        Promise.all(promise_list).then(() => {
          this.url_list = [...this.url_list, ...formUrlArr];
          this.loading = false;
          this.$emit("upload", this.url_list)
        });
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("lbl_an_error_occurred_while_uploading"),
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
      }
    },
    getStatusAndMessage() {
      const processorStatus = this.orderItem?.data?.order_processor?.status;
      const isProcessOrSuccessProcessor = [
        ORDER_FORM_PROCESSOR_STATUS.PROCESSING,
        ORDER_FORM_PROCESSOR_STATUS.COMPLETE
      ].includes(processorStatus);

      this.isSended = this.orderItem?.data?.document_link?.every(
        item => item?.status === RESULT_ORDER_ITEM_STATUS.APPROVE
      );
      
      this.isDisabled = isProcessOrSuccessProcessor || this.isSended || this.isCancelOrder
      this.disableMessage = this.$t(
        this.isDisabled
          ? this.isCancelOrder
            ? "lbl_the_order_has_been_canceled__and_you_cannot_upload_a_file_"
            : this.isSended
              ? "lbl_the_order_has_been_completed__and_you_cannot_upload_a_file_"
              : "lbl_the_order_is_currently_being_processed__and_you_cannot_upload_a_file_"
          : ""
      )
    },
    getFileName(url) {
      if (!url) return "";
      const fileName =
        typeof url === "object" && url.url
          ? url?.url?.substring(url?.url?.lastIndexOf("/") + 1)
          : url?.substring(url?.lastIndexOf("/") + 1);
      return fileName.length > 20 ? appUtils.truncateHash(fileName, 20) : fileName;
    },
  }  
};
</script>

<style lang="scss" scoped>
.button-none {
  background-color: transparent;
  border: none;
  color: white;
  cursor: pointer;
  &:focus-visible {
    outline: #4b6ecf dotted 0.5px;
  }
}
.product-name {
  font-weight: 600;
}
.description {
  font-size: 12px;
  margin-bottom: 5px;
  a {
    text-decoration: underline;
  }
}

.cs-box-item {
  border: 1px solid #20409b;
  padding: 12px;
  border-radius: 4px;
}

.cs-dropdown ::v-deep {
  button {
    background-color: transparent !important;
    padding: 0 !important;
    border: none !important;

    &:hover {
      background-color: transparent !important;
      padding: 0 !important;
      border: none !important;
      box-shadow: none !important;
    }

    &::after {
      display: none !important;
    }
  }
}

svg:focus {
  outline: none;
}
</style>>